import { Environment } from './environment-interface';

const response = await fetch('/assets/configs/environment.json');
const environmentConfig = await response.json();

export const environment: Environment = {
  production: true,
  webAppHost: environmentConfig['webAppHost'],
  oktaClientId: environmentConfig['oktaClientId'],
  oktaDomain: environmentConfig['oktaDomain'],
};
